import { stockTypeEnum } from "@gtpl/shared-models/common-models";
import { RmOccupancyEnum, RmRackPositionEnum, RmRackPositionTypeEnum } from "@gtpl/shared-models/masters";
import {Column,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Rack } from "../racks/racks.entity";
import { RmRack } from "../rm-racks/rm-racks.entity";

@Entity('rm_rack_position')
export class RmRackPosition {
  @PrimaryGeneratedColumn('increment', { name: 'rm_rack_position_id' })
  rmRackPositionId: number;

  @Column("varchar",{
    nullable:false,
    length:20,
    name:"rm_rack_code"
  })
  rmRackCode:string;

  @Column({
    type: 'enum',
    enum: RmRackPositionEnum,
    nullable: false,
    default: RmRackPositionEnum.BACK_CENTER,
    name: 'rm_rack_position'
  })
  rmRackPosition: RmRackPositionEnum;

  @Column('int', {
    nullable: false,
    name: 'rm_rack_level'
  })
  rmRackLevel: number;

  @Column('int', {
    nullable: false,
    name: 'rm_rack_column'
  })
  rmRackColumn: number;

  @Column('int', {
    nullable: false,
    name: 'rm_rack_id'
  })
  rmRackId: number;
  @Column('int', {
    nullable: false,
    name: 'zone_id'
  })
  zoneId: number;
  @Column("text", {
    nullable: false,
    name: "rm_rack_boundaries"
  })
  rmRackBoundaries: string;

  @Column("text", {
    nullable: false,
    name: "assoc_rfid"
  })
  assocRfId: string;

  
  @Column('int', {
    nullable: false,
    name: 'plant_id',
    default:0
  })
  plantId: number;
  @Column('int', {
    nullable: true,
    name: 'rm_rack_position_code'
  })
  rmRackPositionCode: number;
  @Column('int', {
    nullable: true,
    name: 'rm_rack_reserve_code'
  })
  rmRackReserveCode: number;

  @Column('int', {
    nullable: true,
    name: 'sale_order_id'
  })
  saleOrderId: number;
  @Column('int', {
    nullable: true,
    name: 'sale_order_item_id'
  })
  saleOrderItemId: number;
  @Column('int', {
    nullable: true,
    name: 'varient_id'
  })
  varientId: number;
  @Column('int', {
    nullable: true,
    name: 'brand_id'
  })
  brandId: number;
  @Column('int', {
    nullable: true,
    name: 'item_sub_category_id'
  })
  itemSubCategoryId: number;

  @Column({
    type: 'enum',
    enum: RmOccupancyEnum,
    nullable: false,
    default: RmOccupancyEnum.NOT_OCCUPIED,
    name: 'occupancy'
  })
  occupancy: RmOccupancyEnum;
  @Column({
    type: 'enum',
    enum: RmRackPositionTypeEnum,
    nullable: false,
    default: RmRackPositionTypeEnum.REAR,
    name: 'rm_rack_position_type'
  })
  rmRackPositionType: RmRackPositionTypeEnum;
  @Column({
    type: 'enum',
    enum: stockTypeEnum,
    nullable: true,
    default: stockTypeEnum.SaleOrder,
    name: 'reserved_for'
  })
  reservedFor: stockTypeEnum;

  @Column('boolean', {
    nullable: false,
    default: false,
    name: 'is_reserved',
  })
  isReserved: boolean;

  @Column("date", {
    nullable: true,
    name: "reserved_date"
  })
  reservedDate: Date;

  @Column('boolean', {
    nullable: false,
    default: true,
    name: 'is_active',
  })
  isActive: boolean;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    nullable: false,
    name: 'created_user',
    length: 50,
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    nullable: true,
    name: 'updated_user',
    length: 50,
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;
  
  @ManyToOne(type => RmRack, rmRack => rmRack.rmRackPositionInfo, { nullable: false, })
  @JoinColumn({ name: "rm_rack_id" })
  rmRackMasterInfo: RmRack;


}

